module.exports = __webpack_public_path__ + "MuseoSans-700Italic.488d0fb13babc277e050.svg";


//////////////////
// WEBPACK FOOTER
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/assets/fonts/MuseoSans-700Italic.svg
// module id = ../../../../../src/assets/fonts/MuseoSans-700Italic.svg
// module chunks = styles